<template>
  <div v-loading="loading">
    <div class="title">项目概要</div>
    <el-card shadow="hover">
      <div slot="header">
        <span class="brand-color">项目需求</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="16">
          <div class="basic-info">
            <span class="label">选题方向：</span>
            <span>{{ taskInfo.job.name }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="basic-info">
            <span class="label">状态：</span>
            <span>{{ taskInfo.status_label }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16">
          <div class="basic-info" @click="openDialog">
            <span class="label">项目需求：</span>
            <el-link type="primary">{{ taskInfo.name }}</el-link>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="basic-info">
            <span class="label"> 价格范围：</span>
            <span
              >¥ {{ taskInfo.unit_price_min }} - ¥
              {{ taskInfo.unit_price_max }}</span
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="basic-info">
            <span class="label">交付价格：</span>
            <span>-</span>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div slot="header">
        <span class="brand-color">概要设计</span>
      </div>
      <el-form
        class="mt-12"
        label-width="120px"
        :model="projectInfo"
        :rules="topicRules"
        ref="projectInfo"
      >
        <el-form-item label="项目名称：" prop="name" :show-message="false">
          <el-input class="w-90pc" v-model="projectInfo.name"></el-input>
        </el-form-item>
        <el-form-item label="项目难度：" prop="project_difficult_level">
          <el-select
            size="small"
            class="w-200"
            v-model="projectInfo.project_difficult_level"
            placeholder="请选择项目难度"
          >
            <el-option
              v-for="(item, index) in difficultyList"
              :key="index + 1"
              :label="item"
              :value="index + 1"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="岗位级别："
          prop="difficult_level_id"
          :show-message="false"
        >
          <el-select
            class="w-200"
            v-model="projectInfo.difficult_level_id"
            size="medium"
            placeholder="请选择岗位级别"
            clearable
          >
            <el-option-group
              v-for="group in skillModelOptions"
              :key="group.id"
              :label="group.name"
            >
              <el-option
                v-for="item in group.children"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item label="项目类型：" prop="type" :show-message="false">
          <el-select
            class="w-200"
            v-model="projectInfo.type"
            size="medium"
            placeholder="请选择项目类型"
            clearable
          >
            <el-option label="工程型" :value="1"></el-option>
            <el-option label="技能型" :value="2"></el-option>
          </el-select>

          <el-tooltip class="tooltip-item" effect="dark" placement="right">
            <div slot="content">
              1.工程型 - 通过代码实现解决某种（类）问题的工具<br />
              2.技能型 - 使用某个工具或者学习某种思路，来解决某个（类）问题
            </div>
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
        </el-form-item>

        <el-form-item label="行业分类：">
          <el-cascader
            v-model="projectInfo.common_industries"
            :options="industryList"
            :props="optionProps"
            class="w-400"
            placeholder="请选择行业分类"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="前置技能：" prop="type" :show-message="false">
          <ProjectStackSelect
            :stacks="projectInfo.pre_skills"
          ></ProjectStackSelect>
        </el-form-item>

        <el-form-item label="提升目标：" prop="type" :show-message="false">
          <ProjectStackSelect
            :stacks="projectInfo.aim_skills"
          ></ProjectStackSelect>
        </el-form-item>

        <el-form-item label="项目场景：" prop="scene" :show-message="false">
          <el-input
            class="w-90pc"
            type="textarea"
            :rows="2"
            placeholder="请输入项目场景"
            v-model="projectInfo.scene"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="学习目标：" :show-message="false" prop="study_aim">
          <el-input
            class="w-90pc"
            type="textarea"
            :rows="2"
            placeholder="请输入学习目标"
            v-model="projectInfo.study_aim"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="配套资料：" :show-message="false" prop="material">
          <el-input
            class="w-90pc"
            type="textarea"
            :rows="2"
            placeholder="https://github.com/username/repository"
            v-model="projectInfo.material"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="项目拆解：" :show-message="false">
          <DraggableTask :datas.sync="projectInfo.pages"></DraggableTask>
        </el-form-item>
      </el-form>
      <div
        class="submit-btn"
        v-if="authPermissions.includes('project.api.fuwu_admin.projects.store')"
      >
        <el-tooltip
          class="item"
          effect="dark"
          content="提交审核后，会有专门的服务老师对项目大纲进行审核，请认真填写 ～"
          placement="top"
        >
          <zhu-button
            text="提交审核"
            :shadow="true"
            :loading="btnLoading"
            @click="submit(2)"
          ></zhu-button>
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          content="保存草稿后，会保存在我的项目中，可继续完善后再提交审核 ～"
          placement="top"
        >
          <zhu-button
            text="保存草稿"
            :shadow="true"
            type="primary"
            :loading="btnLoading"
            @click="submit(false)"
          ></zhu-button>
        </el-tooltip>
      </div>
    </el-card>
    <el-dialog
      class="skill-task-dialog"
      :visible.sync="dialogVisible"
      width="1000px"
      :show-close="false"
      center
    >
      <markdown-it :md="taskInfo.description"></markdown-it>
    </el-dialog>
  </div>
</template>

<script>
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import projectService from "@/global/service/project";
import kcellService from "@/global/service/kcell";
import ProjectStackSelect from "@/components/ProjectStackSelect";
import DraggableTask from "./widgets/DraggableTask.vue";
import { mapState } from "vuex";

export default {
  components: {
    MarkdownIt,
    DraggableTask,
    ProjectStackSelect
  },
  data() {
    return {
      loading: true,
      btnLoading: false,
      dialogVisible: false,
      taskInfo: {
        job: {}
      },
      selectLoading: false,
      difficultyList: [
        "R1-简单",
        "R2-一般",
        "R3-中等",
        "R4-困难",
        "R5-非常困难"
      ],
      skillModelOptions: [],
      projectInfo: {
        project_task_id: null,
        name: null,
        difficult_level_id: null,
        type: null,
        common_industries: [],
        pre_skills: [],
        aim_skills: [],
        scene: null,
        study_aim: null,
        material: null,
        pages: [],
        description: "",
        project_difficult_level: ""
      },
      topicRules: {
        name: { required: true, trigger: "blur" },
        difficult_level_id: { required: true, trigger: "blur" },
        type: { required: true, trigger: "blur" },
        scene: { required: true, trigger: "blur" },
        study_aim: { required: true, trigger: "blur" },
        project_difficult_level: { required: true, trigger: "blur" }
      },
      industryList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      }
    };
  },
  created() {
    this.getData();
    this.getConst();
  },
  computed: {
    ...mapState(["authPermissions"]),
    projectDuration() {
      return this.projectInfo.pages.reduce((pre, cur) => pre + cur.duration, 0);
    }
  },
  methods: {
    getConst() {
      kcellService.kcellIndustry().then(res => {
        this.industryList = res;
      });
    },
    getData() {
      let id = this.$route.params.id;
      projectService
        .taskItem(id)
        .then(res => {
          this.taskInfo = res;
          this.getPositionSkillModel(res.job.id);
        })
        .finally(() => (this.loading = false));
    },
    getPositionSkillModel(id) {
      kcellService.kcellPositionsSkillModel(id).then(res => {
        this.skillModelOptions = res.levels;
      });
    },
    openDialog() {
      this.dialogVisible = true;
    },
    removeProjectPageInTable(data) {
      const index = this.projectInfo.pages.indexOf(data);
      this.projectInfo.pages.splice(index, 1);
    },
    handleAddProjectPages() {
      this.projectInfo.pages.push({
        name: "",
        description: "",
        duration: null
      });
    },
    submit(status) {
      this.$refs["projectInfo"].validate(val => {
        if (!val) {
          this.$message.error("项目基本设置缺少必要参数");
          return;
        }
        const params = this.projectInfo;
        params.duration = this.projectDuration;
        params.project_task_id = this.$route.params.id;
        params.job_id = this.taskInfo.job.id;
        if (status) {
          params.status = status;
        }
        const hasPreSkills = params.pre_skills.length;
        const hasAimSkills = params.aim_skills.length;
        if (!hasPreSkills) return this.$message.error("前置技能不能为空 ～");
        if (!hasAimSkills) return this.$message.error("目标技能不能为空 ～");
        const hasSelectPreSkillLevel = params.pre_skills.every(
          d => d.level || d.level === 0
        );
        const hasSelectAimSkillLevel = params.aim_skills.every(
          d => d.level || d.level === 0
        );
        if (!hasSelectPreSkillLevel)
          return this.$message.error("前置的技能水平不能为空 ～");
        if (!hasSelectAimSkillLevel)
          return this.$message.error("目标的技能水平不能为空 ～");
        const isFullMessage = params.pages.every(data => {
          return data.name && data.description && data.duration;
        });

        if (!isFullMessage) return this.$message.error("项目拆解信息不全 ～");
        if (!params.pages.length)
          return this.$message.error("项目至少应拥有一个模版页面 ～");
        this.btnLoading = true;
        projectService
          .create(params)
          .then(res => {
            this.$message.success("添加成功");
            this.$router.replace({
              name: "ProjectMyDetail",
              params: { id: res.project_id }
            });
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    }
  }
};
</script>

<style lang="less"></style>
<style lang="less" scoped>
.topic-option .md {
  min-height: 0 !important;
}
.el-card {
  margin-bottom: 30px;
}
.basic-info {
  margin-bottom: 12px;
  font-size: 14px;
  .label {
    display: inline-block;
    width: 90px;
    text-align: right;
  }
}
.topic-option {
  position: relative;
  width: 90%;
  .item-float-delete {
    z-index: 1501;
    position: absolute;
    bottom: 10px;
    right: 12px;
    height: 0;
    overflow: hidden;
    .el-link {
      font-size: 16px;
    }
  }
  &:hover .item-float-delete {
    height: 28px;
  }
}
.option-add-btn {
  margin-left: 120px;
  margin-bottom: 36px;
}
.submit-btn {
  margin: 60px 0 36px;
  text-align: center;
  .el-button {
    width: 220px;
  }
  .el-checkbox {
    display: block;
    margin-top: 12px;
  }
}
.dialog-tree-container {
  padding: 0 40px;
}
.tooltip-item {
  margin-left: 15px;
}
</style>
